module.exports = __webpack_public_path__ + "ploni-aaa-800.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ploni-aaa-800.otf
// module id = 1202
// module chunks = 10